import React from "react";

import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "zadostHistorieItemPoznamka",
  placeholderText: "Poznamka: nejaka tu asi muze byt",
  content: ({ val }) => (
    <div className="b2b-ZadostHistorieItemPoznamka">
      <span className="b2b-ZadostHistorieItemPoznamka-label">{val.label}</span>
      <span className="b2b-ZadostHistorieItemPoznamka-poznamka">
        {val.poznamka}
      </span>
    </div>
  )
});
